import { getPermalink } from '~/utils/permalinks';
import type { Languages } from './ui';
import { ui, defaultLang, showDefaultLang, languages } from './ui';

export function getLangFromUrl(pathname: string) {
  const [, lang] = pathname.split('/');
  if (lang in ui) return lang as keyof typeof ui;
  return defaultLang;
}

export function getCurrentEndpointWithoutLang(pathname: string) {
  const [, lang, ...endpoint] = pathname.split('/');
  if (lang in ui) return endpoint.join("/");
  const [, ...endpoint_] = pathname.split('/');
  return endpoint_.join("/");
}

export function useTranslations(lang: keyof typeof ui) {
  return function t(key: keyof typeof ui[typeof defaultLang]) {
    return ui[lang][key] || ui[defaultLang][key];
  }
}

export function useTranslatedPath(lang: keyof typeof ui) {
  return function translatePath(path: string, l: string = lang) {
    const translatedPath = (!showDefaultLang && l === defaultLang || !(l in languages)) ? path : `/${l}/${path}`;
    const type = translatedPath.includes("/#") ? 'id' : 'page';
    return getPermalink(translatedPath, type);
  }
}

const LOCAL_STORAGE_LANG = "favoriteLanguage";

export function setLocalStorageLanguage(lang: Languages): boolean {
  if (lang === getLocalStorageLanguage()) return false;
  
  localStorage.setItem(LOCAL_STORAGE_LANG, lang);
  return true;
}

export function getLocalStorageLanguage(): string | null {
  const storedLang = localStorage.getItem(LOCAL_STORAGE_LANG);
  return storedLang;
}